<template>
    <div class="invoices-list" v-if="!loading">
        <div class="" v-if="!showInvoices">
            <p>You don't have any invoices so far.</p>
        </div>
        <div class="info"  v-else>
            <table class="table table--overview">
                <thead>
                    <tr>
                        <th>
                            {{$t("user.invoices.number")}}
                        </th>
                        <th>
                            {{$t("user.invoices.created")}}
                        </th>
                        <th>
                            {{$t("user.invoices.total")}}
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <InvoiceItem v-for="invoice in invoices" :key="invoice.id" v-bind="invoice"></InvoiceItem>
                </tbody>
                <tfoot>
                <tr>
                    <td colspan="3">
                        <nav class="page navigation" v-show="showPagination">
                            <b-pagination
                                align="left"
                                v-bind:total-rows="total"
                                v-model="currentPage"
                                v-on:change="goToPage"
                                v-bind:per-page="limit"
                            >
                            </b-pagination>
                        </nav>
                    </td>
                </tr>
                </tfoot>
            </table>
        </div>
    </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'

import InvoiceItem from './InvoiceItem'

export default {

  name: 'InvoicesList',

  components: {
    InvoiceItem
  },

  props: {

    limit: {
      type: Number,
      default: 20
    }
  },

  computed: {

    ...mapState('invoice', {
      globalItems: state => state.items
    }),

    showPagination () {
      return this.totalPages > 1
    },

    showInvoices () {
      return this.invoices.length > 0
    }
  },

  data () {
    return {
      invoices: [],
      currentPage: 1,
      total: 1,
      totalPages: 1,
      sort: 'created_at',
      dir: 'asc',
      searchTerm: '',
      loading: true
    }
  },

  methods: {

    ...mapActions('invoice', [
      'getItems'
    ]),

    goToPage (page) {
      let payload = {
        page: page,
        limit: this.limit,
        sort: this.sort,
        dir: this.dir,
        search: this.searchTerm
      }

      this.getItems(payload).then(
        response => {
          /*
                            Don't use the repose data because we are converting data for easier usage, this is saved
                            locally in the globalItems var to avoid naming conflicts
                         */

          this.preparePage(this.globalItems)
          this.loading = false
        }
      )
    },

    preparePage (data) {
      let meta = data.meta

      this.limit = meta.pagination.per_page
      this.total = meta.pagination.total
      this.totalPages = meta.pagination.total_pages
      this.currentPage = meta.pagination.current_page

      this.invoices = []

      data.data.forEach((e) => {
        this.invoices.push(e)
      })
    }

  },

  created () {
    this.goToPage(1)
  }
}
</script>
